import React from 'react';
import { Box } from '@mui/material';
import { Juror } from '../../../../redux/contest/types';
import { TMoreMenuItem } from '../../../More/more.data';
import { ghostBorderSx, glassCardSx } from '../../../WatchPage/watchCinemaTheme';
import { brandJurorCompactVisibleSx, brandJurorDesktopVisibleSx } from './brandJurorCardLayout';
import { BrandContestJurorCardCompact } from './BrandContestJurorCardCompact';
import { BrandContestJurorCardDesktop } from './BrandContestJurorCardDesktop';

export interface BrandContestJurorCardProps {
    juror: Juror;
    menuItems: TMoreMenuItem[];
    onMenuClick: (type: string, juror: Juror) => void;
}

const cardShellSx = {
    ...glassCardSx,
    ...ghostBorderSx,
    borderRadius: 4,
    overflow: 'hidden',
    maxWidth: '100%',
    boxSizing: 'border-box',
    transition: 'background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease',
} as const;

const BrandContestJurorCard: React.FC<BrandContestJurorCardProps> = ({ juror, menuItems, onMenuClick }) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    ...cardShellSx,
                    ...brandJurorCompactVisibleSx,
                    '&:hover': {
                        bgcolor: 'rgba(42, 42, 42, 0.55)',
                    },
                }}>
                <BrandContestJurorCardCompact
                    juror={juror}
                    menuItems={menuItems}
                    onMenuClick={onMenuClick}
                />
            </Box>

            <Box
                sx={{
                    ...cardShellSx,
                    ...brandJurorDesktopVisibleSx,
                    '&:hover': {
                        bgcolor: 'rgba(42, 42, 42, 0.55)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 12px 28px rgba(0, 0, 0, 0.35)',
                    },
                }}>
                <BrandContestJurorCardDesktop
                    juror={juror}
                    menuItems={menuItems}
                    onMenuClick={onMenuClick}
                />
            </Box>
        </Box>
    );
};

export { BrandContestJurorCard };
